import React, {useEffect, useState} from 'react';

import {AddPolymersModalSharedProps} from 'molbio/bulk-assembly/add-polymers/AddPolymersConstants';
import {updateFragmentsData} from 'molbio/bulk-assembly/add-polymers/AddPolymersUtil';
import {IMMERSIVE_MODAL_PROPS} from 'molbio/bulk-assembly/BulkAssemblyConstants';
import {FragmentModalFragment} from 'molbio/bulk-assembly/polymer-map-modals/FragmentCardContents';
import FragmentsModalContent from 'molbio/bulk-assembly/polymer-map-modals/FragmentsModalContent';
import {fragmentDataToNormalizedFragment} from 'molbio/bulk-assembly/util/BulkAssemblyUtil';
import ModalButtonKey from 'test/lib/cypress/shared/ModalButtonKey';
import {ButtonStyle} from 'ui-library/buttons/Button';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import Modal from 'ui-library/modals/Modal';
import {withLoadingScreen} from 'util/Promises';

export interface AddPolymersModalProps extends AddPolymersModalSharedProps {
  /** API ID of the fragment polymer to add. */
  fragmentPolymerId: string;
}

export default function AddPolymerModal({
  assemblyId,
  binCid,
  binColor,
  binIndex,
  bulkAssemblyMethodData,
  canSpecifyEndpoints,
  canUpdateRestrictionEnzymes,
  constructFragmentIndex,
  constructTopology,
  enableSelectPreferredPrimers,
  fragmentPolymerId,
  fragmentProductionMethod,
  numConstructFragments,
  onRequestSubmit,
  onRequestClose,
  polymerSubtypes,
}: AddPolymersModalProps): JSX.Element {
  const [fragmentsData, setFragmentsData] = useState<Array<FragmentModalFragment>>([]);
  useEffect(() => {
    const update = async (): Promise<void> => {
      await withLoadingScreen(
        updateFragmentsData([fragmentPolymerId], [], setFragmentsData, {
          polymerSubtypes,
          enableSelectPreferredPrimers,
          binCid,
          binColor,
          binIndex,
          constructFragmentIndex,
          canSpecifyEndpoints,
          constructTopology,
          numConstructFragments,
          bulkAssemblyMethodData,
          fragmentProductionMethod,
          canUpdateRestrictionEnzymes,
        })
      );
    };
    update();
  }, [
    fragmentPolymerId,
    setFragmentsData,
    polymerSubtypes,
    enableSelectPreferredPrimers,
    binCid,
    binColor,
    binIndex,
    constructFragmentIndex,
    canSpecifyEndpoints,
    constructTopology,
    numConstructFragments,
    bulkAssemblyMethodData,
    fragmentProductionMethod,
    canUpdateRestrictionEnzymes,
  ]);

  return (
    <Modal
      {...IMMERSIVE_MODAL_PROPS}
      title="Add fragment(s)"
      buttons={[
        {text: 'Cancel', cancel: true},
        {
          text: 'Add',
          submit: true,
          style: ButtonStyle.SECONDARY,
          dataTestAttrs: {component: 'AddPolymerModal', key: ModalButtonKey.ADD},
        },
      ]}
      onRequestClose={onRequestClose}
      onRequestSubmit={() => {
        const result = fragmentsData.map((fragmentData) => fragmentDataToNormalizedFragment(fragmentData));
        onRequestSubmit(result);
      }}
    >
      {fragmentsData.length > 0 ? (
        <FragmentsModalContent
          assemblyId={assemblyId}
          bulkAssemblyMethod={bulkAssemblyMethodData}
          canSpecifyEndpoints={canSpecifyEndpoints}
          fragmentsData={fragmentsData}
          setFragmentsData={setFragmentsData}
          isReadOnly={false}
          constructTopology={constructTopology}
          numConstructFragments={numConstructFragments}
        />
      ) : (
        <CenteredHorizontalThrobber />
      )}
    </Modal>
  );
}
